import { render, staticRenderFns } from "./SelectStickerMenu.vue?vue&type=template&id=64505dfa"
import script from "./SelectStickerMenu.vue?vue&type=script&lang=js"
export * from "./SelectStickerMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64505dfa')) {
      api.createRecord('64505dfa', component.options)
    } else {
      api.reload('64505dfa', component.options)
    }
    module.hot.accept("./SelectStickerMenu.vue?vue&type=template&id=64505dfa", function () {
      api.rerender('64505dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stickerMenu/SelectStickerMenu.vue"
export default component.exports